import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { FacilityService } from 'src/app/services/facility.service';
import { PatientListService } from '../../patient-list/patient-list-service';
import * as global from '../../global';
import { DashboardService } from '../../dashboard/dashboard.service';
import { TranscriptionCreateService } from '../../transcription-create/transcription-create.service';

import * as moment from 'moment';
import { PatientRoundingSheetService } from '../../patient-rounding-sheets/patient-rounding-sheet.service';
import { lastValueFrom } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormControl } from '@angular/forms';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { API_URL } from '../../../../environments/api-url';
import { HttpResponse } from '@angular/common/http';
import { PCCService } from 'src/app/services/pcc.service';
import { PatientDocumentsUploadDialog } from '../../patient-documents-list/patient-documents-upload-dialog/patient-documents-upload-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FaceSheetService } from '../../patient-detail/facesheet/face-sheet.service';
import { FileExplorerService } from '../../drive/file-explorer/file-explorer.service';

@Component({
  selector: 'app-admin-side-patients',
  templateUrl: './admin-side-patients.component.html',
  styleUrls: ['./admin-side-patients.component.css']
})
export class AdminSidePatientsComponent implements OnInit {
  facilities: any = [];
  currentUser: any = [];
  allPatients: any = [];
  assocProviders: Array<any> = [];
  associatedProvidersIDs: Array<any> = [];
  dataSource: any;
  applySearchFilter: Boolean = false;
  activeAlphabeticBarIndex = 'All';
  global = global;
  dob: any;
  index:any='';
  patientRoundingSheets: any[] = [];
  displayedColumns = ['name', 'gender', 'date_of_birth', 'facility', 'face_sheet', 'last_cpt', 'last_seen','ipa','operations']
  filter: any = {
    dob: '',
    provider: '',
    active: true,
    company_id: '',
    facility: '',
    patientName: '',
    dn_mrnNo: '',
    pcc_mrnNo: '',
    patient_ssn: ''
  }
  public pagination: {
    pageNo: number,
    hasNextPage: boolean,
    hasPrevPage: boolean,
    totalCount: number,
    totalPages: number
  };
  loaderId = 'patient-list-loader';
  searchProviderText: any;
  searchFacilityText: any;
  timeoutId: any;
  searchCompanyBase:boolean=false;
  adminRoute: boolean = false;
  companyRoute: boolean = false;
  company: any;
  advanceSearchList: boolean = false;
  configureMedicalHistoryRoute: any = '';
  @ViewChild(MatSort) sort: MatSort;
  editingPatient: boolean = false;
  // @Output() onAddNewClick: EventEmitter<any> = new EventEmitter();
  constructor(

    private _patientRoundingSheets: PatientRoundingSheetService,
    private _dashboardService: DashboardService,
    private router: Router,
    private route: ActivatedRoute,
    private facilityService: FacilityService,
    private authService: AuthService,
    private _patientListService: PatientListService,
    private _transcriptionCreateService: TranscriptionCreateService,
    private loader: NgxUiLoaderService,
    private companyService: CompanyService,
    private pccService: PCCService,
    private _faceSheetService: FaceSheetService,
    private dialog: MatDialog,
    private _toastr: ToastrService,
    private fileExplorerService: FileExplorerService,

  ) {
    this.currentUser = this.authService.currentUser;
    this.pagination = {
      pageNo: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalCount: 0,
      totalPages: 0
    };
    if (this.router.url.indexOf('/admin') === 0) {
      this.adminRoute = true;
    } else if (this.router.url.indexOf('/company') === 0) {
      this.companyRoute = true;
    }
  }

  async ngOnInit() {
    const searchAllPatients = localStorage.getItem( 'admin-side-patients:searchAllPatients' );
    if (window.location.pathname.includes('company')) {
      this.filter.company_id = this.route.parent.parent.snapshot.params.id;
    }
    else {
      this.filter.company_id = ''
    }
    this.configureMedicalHistoryRoute = `/company/${this.filter.company_id || this.currentUser.company_id}/patients/patient-medical-history`;
    const {status, data} = await this.companyService.getCompanyName(this.currentUser.company_id).toPromise();
    if(status === 200){
      this.company = data;
      if(!this.company.should_show_ipa){
        this.displayedColumns = this.displayedColumns.filter((column) => {
          return column !== 'ipa'
        });
      }
    }
    console.log('window.location.href', this.filter.company_id)
    if (window.location.href.toString().includes('advance-search-list')) {
      // this.displayedColumns = ['checkbox', 'name', 'date_of_birth', 'facility', 'mrn', 'face_sheet', 'last_cpt', 'last_seen', 'operations'];
      // if (this.isNurseUser) {
      //   this.displayedColumns = this.displayedColumns.filter(column => { if (column != 'checkbox' && column != 'operations') return column })
      // }
      this.advanceSearchList = true;
      // if (localStorage.getItem("advance-search") != null) {
      //   this.useFiltersforAdvanceSearch = true;
      //   this.filter = JSON.parse(localStorage.getItem("advance-search"));
      // } else {
      //   this.useFiltersforAdvanceSearch = false;
      // }
      this.filter.dob ? this.getdob() : this.filter.dob = '';
      // if (this.isNurseUser) {
      //   if (!this.advanceSearchList || this.useFiltersforAdvanceSearch) {
      //     this.initPatients(1);
      //   }
      // }
    }
    if(!this.advanceSearchList) {
      const isPatientName = localStorage.getItem('patient_list_name');
      if (isPatientName) {
        this.filter.patientName = isPatientName;
      }
      const isDOB = localStorage.getItem('patient_list_dob');
      if (isDOB) {
        let dobDate = moment(isDOB);
        this.dob=dobDate;
        let date = moment(isDOB).format(global.moment_date_format2);
        this.filter.dob = date;
      }
      // await this.getFacilities();
    await this.initAssocProviders();
    if (this.assocProviders?.length > 0) {
        this.sortProviders(this.assocProviders);
      let providerID = localStorage.getItem("patient_list_provider")
      if (providerID !== null && this.associatedProvidersIDs.includes(providerID)) {
        await this.initFacilities(providerID);
      }
        else {
          await this.initFacilities(this.currentUser._id);
          const isFacilitySelected = localStorage.getItem('patient_list_facility');
          if(isFacilitySelected) {
            this.filter.facility = isFacilitySelected;
          }
        }
      }
      if (this.facilities?.length > 0 && searchAllPatients !== 'true') {
        this.initPatients(1);
        if (this.currentUser.user_type === global.USER_TYPE.DOCTOR || this.currentUser.user_type === global.USER_TYPE.SNF_WC_NURSE) {
          this.initPatientRoundingSheets(this.currentUser._id, this.filter.facility);
        } else if (this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT || this.currentUser === global.USER_TYPE.TRANSCRIBER) {
          this.initPatientRoundingSheets();
        }
      }
      if( searchAllPatients === 'true' ) {
        this.searchCompanyBase = true;
        this.filter.facility = '';
        this.filterOnPatiens();
      }
    }
    
  }
  getdob() {
    const date = new Date(this.filter.dob).getDate();
    const [m, d, y] = this.filter.dob.split(' ');
    const newDate = moment(new Date(this.filter.dob)).set({ 'year': y, 'month': m, 'date': date });
    this.dob = newDate;
  }
  async getFacilities() {
    await this.facilityService.getAllFacilities(this.filter).subscribe((response: any) => {
      if (response.status == 200) {
        this.facilities = this.sortTitleVise(response.data.array);
        this.filter.facility = this.facilities[0]._id;
        this.initPatients(1);
      }
    })
  }
  async initPatients(page, index = null) {

    var details = {
      id: <string>null,
      auth_key: <string>null,
      usertype: <any>null,
      primary_doctor_id: <string>null,
      index: <string>null
    };
    details.id = this.currentUser._id;
    details.auth_key = this.currentUser.auth_key;
    details.usertype = this.currentUser.user_type;
    details.index = index;
    // this.loader.startLoader(this.loaderId);

    // if (this.filter.facility) {
    //   await this.getPatientsByFacilityId(details, page);

    // }
    this.getPatientsV2(index, page);
    // this.loader.stopLoader(this.loaderId); 
  }

  isPCCFacility(facility_id) {
    for(const facility of this.facilities) {
      if(facility_id === facility._id) {
        if(facility.pcc_facId) {
          return true;
        }
      }
    }
  }
  isMatrixFacility(facility_id){
    for(const facility of this.facilities) {
      if(facility_id === facility._id) {
        if(facility.source == 'MatrixCare') {
          return true;
        }
      }
    }
  } 
  
  async getPatientsByFacilityId(item, page) {
    // DOCTOR 1
    // const infoToast = this._toastr.info("Fetching patients...", "Please wait");
    const response: any = await this._patientListService.getPatientsByFacilityId(item, page, this.filter).toPromise();
    if (response.status === 200) {
      this.allPatients = response.data.array
        .filter(patient => patient.is_active === 'true');
      const totalCount = response.data.totalCount;
      this.pagination.totalCount = totalCount;
      this.pagination.pageNo = page;
      this.initPagination();
      this.initTableDataSource(this.allPatients);
      this.dataSource.sort = this.sort;
    }
  }
  
  async getPatientsV2(index, page) {
    // if (this.filter.patientName == '') {
    //   localStorage.removeItem('patient_list_name');
    // }
    // if (this.filter.dob == '') {
    //   localStorage.removeItem('patient_list_dob');
    // }
    // const provider = this.assocProviders.find(provider => provider._id === this.filter.provider);
    // // const company_id = provider.company_id;
    // const company_id = this.route.parent.snapshot.params.id;
    // let facility_id = this.filter.facility;
    // const searchText = this.filter.patientName;
    // const dob = this.filter.dob;
    // let provider_id;
    this.loader.startLoader(this.loaderId);
    // if(!facility_id || facility_id === 'undefined') {
    //   provider_id = provider._id;
    //   facility_id = undefined;
    // }
    let provider, company_id, provider_id, mrnNo, pcc_mrnNo, facility_id,patient_ssn;
    const searchText = this.filter.patientName;
    const dob = this.filter.dob;
    if (!this.advanceSearchList) {
      this.filter.dn_mrnNo = '',
      this.filter.patient_ssn = '';
      this.filter.pcc_mrnNo = '';
      if(!this.filter.facility){
        if(this.facilities.length > 0){
          this.filter.facility = this.facilities[0]._id
        } 
      }
      else {
        facility_id = this.filter.facility;
      }
      provider = this.assocProviders.find(provider => provider._id === this.filter.provider);
      provider_id = provider._id;
      company_id = this.filter.company_id;
      // if(this.searchList){
      //   localStorage.setItem("myPatientTab:search", JSON.stringify(this.filter));
      // }
      if (!facility_id || facility_id === 'undefined') {
        provider_id = provider._id;
        facility_id = undefined;
      }
    } else {
      company_id = this.filter.company_id;
      mrnNo = this.filter.dn_mrnNo;
      pcc_mrnNo = this.filter.pcc_mrnNo;
      patient_ssn = this.filter.patient_ssn
      
    }
    // let nurseUserId;
    // if (this.isNurseUser) {
    //   nurseUserId = this.currentUser._id;
    // }
    let serachPatient = true;
    if(this.searchCompanyBase) {
      if(!searchText && !dob) {
        serachPatient = false;
      }
    }
    if(serachPatient) {
      const { data, status, message } = await lastValueFrom(this._patientListService.getPatientsV2(company_id, facility_id, provider_id, searchText, dob, page, index, mrnNo, pcc_mrnNo,patient_ssn)) as any;
      if (status === 200) {
        this.allPatients = data.array.filter(patient => patient.is_active === 'true');
        const totalCount = data.totalCount;
        this.pagination.totalCount = totalCount;
        this.pagination.pageNo = page;
        this.loader.stopLoader(this.loaderId);
      } else {
        this.allPatients = [];
        this.pagination.totalCount = 0;
        this.pagination.pageNo = 1;
        this.loader.stopLoader(this.loaderId);
      }
    } 
    else {
      this.allPatients = [];
      this.pagination.totalCount = 0;
      this.pagination.pageNo = 1;
      this.loader.stopLoader(this.loaderId);
    }
    this.initPagination();
    this.initTableDataSource(this.allPatients);
    this.dataSource.sort = this.sort;
  }
  initPagination() {
    this.pagination.totalPages = Math.ceil(this.pagination.totalCount / 50);
    if (this.allPatients) {
      this.pagination.hasNextPage = this.allPatients.length > 0 && this.pagination.pageNo < this.pagination.totalPages;
    }
    this.pagination.hasPrevPage = this.pagination.pageNo > 1;
    // this.loader.stopLoader('loader-01');
  }
  handleNextClick() {
    this.initPatients(this.pagination.pageNo + 1,this.index);
  }

  handlePrevClick() {
    this.initPatients(this.pagination.pageNo - 1,this.index);
  }
  getcountofPatients() {
    return ( this.allPatients.length > 0 ? (this.pagination.pageNo * 50) - 49 : 0 ) + ' - ' + (((this.pagination.pageNo * 50) - 50) + Number(this.allPatients.length)) + " out of " + (this.pagination.totalCount);
  }

  initTableDataSource(patients) {
    this.dataSource = new MatTableDataSource(patients);
  }
  applyFilter(filterValue: string) {
    localStorage.setItem("patient_list_name", filterValue);
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      // this.hasFacilitiesLoaded = true;
      if(this.filter.patientName){
        if(this.filter.patientName.length >= 3){
          this.initPatients(1)
        }
      }else{
        this.initPatients(1)
      }
    }, 1000);
    // this.applySearchFilter = true;
    // this.filter.patientName = filterValue.trim();
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // this.dataSource.filterPredicate = function (data, filter: string): boolean {
    //   return data.name.toLowerCase().includes(filter);
    // };
  }
  clearFilter() {
    this.filter.active = true;
    this.filter.dob = '';
    this.applySearchFilter = false
    this.filter.facility = Array.isArray(this.facilities) && this.facilities.length > 0 ? this.facilities[0]._id : ''
    this.filter.patientName = '';
    this.filter.dn_mrnNo = '',
    this.filter.patient_ssn = '';
    this.filter.pcc_mrnNo = '';
    this.dob = null;
    this.searchCompanyBase=false;
    localStorage.removeItem('admin-side-patients:searchAllPatients');
    this.initPatients(1)
  }

  getLastSeen(patient) {
    let company_id=this.currentUser?.company_id?.toString()
    if (window.location.pathname.includes('company')) {
      company_id = this.route.parent.snapshot.params.id?.toString();
    }
    let last_seen='-';
    if(patient?.last_seen){
        if(Array.isArray(patient?.last_seen)&&patient?.last_seen?.length){

            for(let element of patient?.last_seen) {
                if(element.company_id?.toString().includes(company_id)){
                    last_seen= element.last_seen||'';
                    break;
                }
            };

        }else{
            last_seen= patient?.last_seen||'';
        }
    }
    return last_seen;

    //return  this.patient?.last_seen||'';
    // let lastSeen = '';
    // const { recentNote } = patient;
    // if (recentNote && recentNote.doctor_id_ref) {

    //   const { first_name, last_name } = recentNote.doctor_id_ref;
    //   lastSeen += `${first_name[0]}${last_name[0]}`.toUpperCase();
    //   // lastSeen += ` - ${moment(new Date(recentNote.filterServiceDate).toLocaleString('en-US', { timeZone: recentNote.timezone })).format('M/D/YYYY')}`;
    //   if (recentNote.date_obj) {
    //     lastSeen += ` - ${this.commonService.dateObjToString(recentNote.date_obj, false)}`;
    //   }
    //   else {
    //     const [year, month, day] = this.commonService.convertDateToStringforMoment(moment(recentNote.filterServiceDate)).split("-");
    //     lastSeen += ` -${month}/${day}/${year}`;
    //   }
    // }
    // return lastSeen;
  }
  async handleUploadFacesheetClick(element, index) {
    this.showPatientDocumentsUploadDialog(index, element._id)
  }
  showPatientDocumentsUploadDialog(index, patientId) {
    const dialogRef = this.dialog.open(
      PatientDocumentsUploadDialog,
      { width: '80%' }
    );
    dialogRef.beforeClosed().subscribe(async (fileInput: any) => {
      if (fileInput) {
        const [file] = fileInput.files;
        const infoToast = this._toastr.info('Uploading Face Sheet...', 'Please wait')
        const company_id = this.company._id;
        this._faceSheetService.uploadFaceSheet(file, patientId, company_id).subscribe((response: any) => {
          if (response.status === 200) {
            const { _id, title, aws_path } = response.data;
            const faceSheet = {
              _id,
              title,
              aws_path
            };
            this.allPatients[index].faceSheet = faceSheet
            this.dataSource = new MatTableDataSource(this.allPatients);
            this.dataSource.sort = this.sort;
            this._toastr.success("Face Sheet Uploaded", 'Success');
          }
          else {
            console.error(response.data.status, response.data.message);
            this._toastr.error(response.data.message, 'Failed');
          }
        });
      }
    });
  }
  downloadFaceSheetActive(element) {
    if (!element) return true;
    if (element.source === 'PointClickCare') return false;
    if (element.source === 'MatrixCare') return false;
    if (element.faceSheet) return false;
    return true;
  }
  async handleDownloadFacesheetClick(element, index) {
    const patient = element;
    if(element?.faceSheet?.aws_path){
      let aws_path = element.faceSheet.aws_path;
      let title = element.faceSheet.title;
      let patient_id = element._id;
      this._faceSheetService.downloadUploadedFile(aws_path, title, patient_id);
    }
    else{
      const details = {
        ...this.authService.authObject,
        patientId: patient._id,
      }
      this._faceSheetService.generateFacesheetAndDownloadAsPDF({}, details)
    }
  }
  filterOnPatiens() {
    this.filter.active = true;
    this.initPatients(1);
    if ((this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT || this.currentUser.user_type === global.USER_TYPE.TRANSCRIBER) && this.filter?.provider !== undefined && this.filter?.facility !== undefined) {
      this.initPatientRoundingSheets(this.filter.provider, this.filter.facility);
    }

    else if (this.currentUser.user_type === global.USER_TYPE.DOCTOR || this.currentUser.user_type === global.USER_TYPE.SNF_WC_NURSE) {
      this.initPatientRoundingSheets(this.currentUser._id, this.filter.facility);
    }
  }
  handleAphabeticIndexButtonClick(index) {
    this.index=index;
    this.initPatients(1, index);
  }
  onAddNewClick() {
    this.router.navigate([`/company/${this.filter.company_id}/patient-add`]);
    // this.showPatientAddDialog();
  }
  onEditPatient(patient_id) {
    this.editingPatient = true;
    this.router.navigate([`/company/${this.filter.company_id}/admin-patient-edit/${patient_id}`]);
    // this.showPatientAddDialog();
  }
  sortFirstNameVise(arrayTosort){
    let users=arrayTosort;
    let result=users.sort(function(a, b){
        if(a.first_name?.toLowerCase() < b.first_name?.toLowerCase()) { return -1; }
        if(a.first_name?.toLowerCase() > b.first_name?.toLowerCase()) { return 1; }
        return 0;
    })
    return result;
  }
  sortTitleVise(arrayTosort){
    let users=arrayTosort;
    let result=users.sort(function(a, b){
        if(a.title?.toLowerCase() < b.title?.toLowerCase()) { return -1; }
        if(a.title?.toLowerCase() > b.title?.toLowerCase()) { return 1; }
        return 0;
    })
    return result;
  }

  async initAssocProviders() {
    // const item:any = {
    //   id: this.currentUser._id,
    //   auth_key: this.currentUser.auth_key,
    //   usertype: this.currentUser.user_type
    // }
    if (this.adminRoute || this.companyRoute) {
      console.log('this.filter.company_id',this.filter.company_id)
      const assocProvidersResponse: any = await this.companyService.getCompanyAllUsers(this.filter.company_id, 1).toPromise();
      if (assocProvidersResponse.status === 200) {
        this.assocProviders = assocProvidersResponse.data.array;
        this.associatedProvidersIDs = this.assocProviders.map(provider => provider._id);
      }
      if (!this.filter.provider) {
        this.assocProviders.forEach((e)=>{
          if(e._id == this.currentUser._id) {
            this.filter.provider = this.currentUser._id;
          }else {
            this.filter.provider = this.assocProviders[0]._id;
          }
        })
        

        await this.getLocalStoredProviderID();
      }
    }else{
      if (this.currentUser.user_type == 2) {
        const assocProvidersResponse: any = await this._dashboardService.getAssociatedDoctorsList(this.currentUser.company_id).toPromise();
        if (assocProvidersResponse.status === 200) {
          this.assocProviders = this.sortFirstNameVise(assocProvidersResponse.data);
          this.associatedProvidersIDs = this.assocProviders.map(provider => provider._id);
        }
        if (!this.filter.provider) {
          this.filter.provider = this.currentUser._id;
          await this.getLocalStoredProviderID();
        }
      }
      if (this.currentUser.user_type == global.USER_TYPE.MEDICAL_ASSISTANT) {
        const assocProvidersResponse: any = await this._transcriptionCreateService.getAssociatedDoctorsListForMA().toPromise();
        if (assocProvidersResponse.status === 200) {
          this.assocProviders = assocProvidersResponse.data;
          this.associatedProvidersIDs = this.assocProviders.map(provider => provider._id);
        }
        if (!this.filter.provider) {
          this.filter.provider = this.currentUser._id;
          await this.getLocalStoredProviderID();
        }
      }
      else if (this.currentUser.user_type == 1) {
        const assocProvidersResponse: any = await this._dashboardService.getP2PRelation().toPromise();
        if (assocProvidersResponse.status === 200) {
          this.assocProviders = assocProvidersResponse.data.assoc_provider_id;
          this.assocProviders.unshift(this.currentUser);
          this.associatedProvidersIDs = this.assocProviders.map(provider => provider._id);
        }
        if (!this.filter.provider) {
          this.filter.provider = this.currentUser._id;
          await this.getLocalStoredProviderID();
        }
      }
    }
  }
  getLocalStoredProviderID() {
    let providerID = localStorage.getItem("patient_list_provider")
    if (providerID !== null && this.associatedProvidersIDs.includes(providerID)) {
      this.filter.provider = providerID;
    }
  }
  handleProviderChange(e) {
    localStorage.setItem("patient_list_provider", e);
    this.initFacilities(this.filter.provider);
  }
  handleFacilityChange(e) {
    this.filterOnPatiens();
    localStorage.setItem('patient_list_facility',e);
  }
  searchByCompany(event: MatCheckboxChange) {
    if (event.checked) {
      localStorage.setItem('admin-side-patients:searchAllPatients', 'true');
      this.searchCompanyBase = event.checked;
      this.filter.facility = '';
      //this.filterOnPatiens();
      this.filter.dob = '';
      this.dob = null;
      this.filter.patientName = '';
      this.filter.dn_mrnNo = '',
      this.filter.patient_ssn = '';
      this.filter.pcc_mrnNo = '';
      this.dataSource.data = [];
      this.allPatients = [];
      this.pagination.totalCount = 0;
      this.pagination.pageNo = 1;
      this.initPagination();
    }
    if (!event.checked) {
      localStorage.removeItem('admin-side-patients:searchAllPatients');
      this.searchCompanyBase = event.checked;
      this.clearFilter();
    }
  }
  async initFacilities(provider_id) {
    // const item:any = {
    //   id: this.currentUser._id,
    //   auth_key: this.currentUser.auth_key,
    //   usertype: this.currentUser.user_type
    // }
    if (this.currentUser.user_type == global.USER_TYPE.DOCTOR || this.currentUser.user_type == global.USER_TYPE.BILLER) {
      const facilitiesResponse: any = await this._transcriptionCreateService.getFacilities(provider_id).toPromise();
      if (facilitiesResponse.status === 200) {
        this.facilities = facilitiesResponse.data.array;
      }
    } else if (this.currentUser.user_type == 2 || this.currentUser.user_type == global.USER_TYPE.MEDICAL_ASSISTANT) {
      // const associatedFacilityOfTranscriberResponse: any = await this._dashboardService.getAssociatedFacilityOfTranscriber().toPromise();
      const associatedFacilityOfTranscriberResponse: any = await this._transcriptionCreateService.getFacilities(provider_id).toPromise();
      if (associatedFacilityOfTranscriberResponse.status === 200) {
        this.facilities = associatedFacilityOfTranscriberResponse.data.array;
      }
    }
    let facilitiesIDs = this.facilities.map(facility => facility._id);
    if (!facilitiesIDs.includes(this.filter.facility)) {
      this.filter.facility = this.filter.facility = this.facilities[0]._id;
    }
    if (!this.filter.facility && Array.isArray(this.facilities) && this.facilities.length > 0) {
      this.filter.facility = this.facilities[0]._id;
      if (localStorage.getItem("patient_list_facility") === null) {
        localStorage.setItem("patient_list_facility", this.facilities[0]._id);
        this.initPatientRoundingSheets(this.facilities[0]._id);
      }
    }
    if (Array.isArray(this.facilities) && this.facilities.length > 0) {
      if (localStorage.getItem("patient_list_facility") !== null) {
        const fac = localStorage.getItem("patient_list_facility")?.toString();
        if ( this.facilities.findIndex((e:any)=>{return e._id?.toString()==fac}) >= 0 ){          
          this.filter.facility = localStorage.getItem("patient_list_facility");
        } else {
          this.filter.facility = this.facilities[0]._id;
          localStorage.setItem("patient_list_facility", this.facilities[0]._id);
        }
      }
    }
    const searchAllPatients = localStorage.getItem( 'admin-side-patients:searchAllPatients' );
    if(searchAllPatients !== 'true'){
      this.initPatients(1);
    }
  }
  initPatientRoundingSheets(provider_id?, facility_id?) {
    // const details = {
    //   ...this.currentUserDetails
    // }
    this._patientRoundingSheets.getCensusList(facility_id, provider_id).subscribe((response: any) => {
      if (response.status === 200) {
        this.patientRoundingSheets = response.data.array;
      }
    })
  }

  onDateChange(event) {
    if (event.value) {
      let filterDOB = new Date(event.value);
      localStorage.patient_list_dob = filterDOB;
      this.dob = '';
      this.dob = event.value;
      this.filter.dob = moment(event.value).format(global.moment_date_format2);
      this.filterOnPatiens()
    } else {
      localStorage.removeItem('patient_list_dob');
      this.dob = '';
      this.filter.dob = '';
      this.filterOnPatiens()
    }
  }
  goToPatientDetailScreen(patient) {
    this.editingPatient = true;
    return this.router.navigate([`/company/${this.filter.company_id}/patient-detail/${patient._id}`]);
  }
  sortProviders(arr: any[]) {
    arr.sort((a, b) => a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase()));
  }

  ngOnDestroy() {
    if (!this.editingPatient) {
      localStorage.removeItem('patient_list_facility');
      localStorage.removeItem('patient_list_name');
      localStorage.removeItem('patient_list_dob');
      localStorage.removeItem('admin-side-patients:searchAllPatients');
    }
  }

}
